// extracted by mini-css-extract-plugin
module.exports = {"container-main":"Main_container-main__3E2Ud","list-countries":"Main_list-countries__1FojH","card":"Main_card__1BJWX","card-content":"Main_card-content__5RkJe"};